import { render, staticRenderFns } from "./NewQuotation.vue?vue&type=template&id=36c0de6b&scoped=true&"
import script from "./NewQuotation.vue?vue&type=script&lang=js&"
export * from "./NewQuotation.vue?vue&type=script&lang=js&"
import style0 from "./NewQuotation.vue?vue&type=style&index=0&id=36c0de6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c0de6b",
  null
  
)

export default component.exports